import axios from 'utils/axiosUtil';
import { USER_SYSTEM_CONTROL } from 'constants/apiURL';

/**
 * 作業予約かそれ以外の予約かどうかを判定
 * @param {string} chubunCd 中分類コード
 * @returns {boolean} 作業予約の場合true、それ以外の場合false
 */
export const isWorkReservation = chubunCd => {

  // nullやundefinedなどを考慮し、3桁の文字列でない場合はfalseを返す
  if (String(chubunCd).length !== 3) {
    return false;
  }

  // 作業予約ではない中分類コード
  return !['003', '005', '021', '022', '023', '029'].includes(chubunCd);
};

/**
 * 動的制御
 * @param {string} value 動的制御対象の値
 * @returns {Promise<boolean>} 1の場合true、それ以外の場合false
 */
export const control = async value => {
  try {
    const response = await axios.get(USER_SYSTEM_CONTROL, {
      params: { controlCode: value },
      ignoreError: true,
      hiddenLoading: true,
    });

    const controlValue = String(response?.body);

    return controlValue === '1';
  } catch (error) {
    return false;
  }
};
